import { Route, Switch } from "react-router-dom";
import {
  AccountSetup,
  Dashboard,
  Integrations,
  Transactions,
  Contacts,
  NewContact,
  UpdateContact,
  // Contracts,
  // SmartContracts,
  // SmartQuotes,
  Invoices,
  PayBills,
  NewInvoice,
  // PaymentMethods,
  ConnectPaymentMethod,
  Support,
  Settings,
  AccountStatement,
  MoveMoney,
  Plaid,
  KYBLanding,
  // Bills,
  // CreateABill,
  // ContractDetails,
} from "@/pages/index.js";
import { NoMatch } from "@/components/no-match-redirect";
import EditInvoice from "@/pages/invoices/edit-invoice";
import InvoiceSettings from "@/pages/invoices/invoice-settings";
import MerchantProcessingOnboarding from "@/pages/merchant-processing/MerchantProcessingOnboarding";
import MerchantProcessingLanding from "@/pages/merchant-processing/MerchantProcessingLanding";
import AuthUserStart from "@/pages/auth/auth-user-start";
import { usePlatformUser } from "@/hooks/tenancy/use-platform-user";
import { MainLoadingWrapper } from "@/pages/styled";
import { CircularProgress } from "@mui/material";
import SweepsSetup from "@/pages/sweeps/setup";
import PayInvoicePreviewPage from "@/pages/pay-invoice-preview/pay-invoice-preview";

const ClientRoutes = () => {
  const { data: platformUser, isLoading, error } = usePlatformUser();
  const pendingAuthUser = platformUser?.flags?.pending_auth_user;
  const baasStatus = platformUser?.baas_status;

  if (isLoading && error?.response?.status !== 404) {
    return (
      <MainLoadingWrapper>
        <CircularProgress disableShrink />
      </MainLoadingWrapper>
    );
  }

  if (pendingAuthUser && baasStatus === "not_started") {
    return (
      <Switch>
        <Route path="*" component={AuthUserStart} />
      </Switch>
    );
  }

  return (
    <Switch>
      <Route path="/account-setup" exact component={AccountSetup} />
      <Route path="/dashboard" component={Dashboard} />
      {/* <Route exact path="/bills" component={Bills} /> */}
      {/* <Route path="/bills/create" component={CreateABill} /> */}
      <Route path="/kyb" component={KYBLanding} />
      <Route path="/integrations" component={Integrations} />
      <Route path="/transactions" component={Transactions} />
      <Route exact path="/contacts/update/:id" component={UpdateContact} />
      <Route exact path="/contacts" component={Contacts} />
      <Route path="/new-contact" component={NewContact} />
      {/* <Route path="/quotes/:id" component={ContractDetails} />
      <Route path="/quotes" component={Contracts} />
      <Route path="/smart-quotes" component={SmartQuotes} /> */}
      <Route exact path="/invoices" component={Invoices} />
      <Route exact path="/pay-bills" component={PayBills} />
      <Route exact path="/invoices/settings/merchant" component={MerchantProcessingLanding} />
      <Route path="/invoices/settings/merchant/:step" component={MerchantProcessingOnboarding} />
      <Route path="/invoices/settings" component={InvoiceSettings} />
      <Route path="/invoices/new" component={NewInvoice} />
      <Route path="/invoices/edit/:id" component={EditInvoice} />
      <Route path="/invoicing" component={PayInvoicePreviewPage} />
      {/* <Route path="/payment-methods" component={PaymentMethods} /> */}
      <Route path="/create-payment" component={ConnectPaymentMethod} />
      <Route path="/support" component={Support} />
      <Route path="/settings" component={Settings} />
      <Route path="/account-statement" component={AccountStatement} />
      <Route path="/move-money" component={MoveMoney} />
      <Route path="/sweeps/setup" component={SweepsSetup} />
      <Route path="/plaid" component={Plaid} />

      <Route path="/" exact component={Dashboard} />
      <Route path="*" component={NoMatch} />
    </Switch>
  );
};

export default ClientRoutes;
